import deportivoVertical from '../images/deportivo_vertical.jpg';
import descontracturanteCervical from '../images/photoshoot_descontracturante_cervical.jpg';
import descontracturanteEspalda from '../images/photoshoot_descontracturante_espalda.jpg';
import descontracturantePiernas from '../images/photoshoot_descontracturante_pierna.jpg';
import descontracturanteCorto from '../images/photoshoot_completo_corto.jpg';
import descontracturanteLargo from '../images/photoshoot_completo_largo.jpg';
// import relajanteLargo from '../images/photoshoot_masaje_relajante_largo.jpg';
import relajanteLargo from '../images/photoshoot_relajante_largo_2.jpg';
import relajanteCorto from '../images/photoshoot_relajante_corto.jpg';
import piesVertical from '../images/pies_vertical.jpg';
import craneoFacial from '../images/photoshoot_craneo_facial.jpg';
import anticelulitico from '../images/photoshoot_anticelulitico.jpg';
import circulatorio from '../images/photoshoot_circulatorio.jpg';
import origPies from '../images/orig_pies.jpg';

const listaMasajes = [
    {
        title: 'Masaje Relajante Corto',
        altTitle: 'Masaje Relajante Corto (50min)',
        text: 'Alivia tensiones y estrés.',
        img: relajanteCorto,
        imgFull: relajanteCorto,
        precio: 30,
        duracion: 50,
        duracionBloque: 60, // Redondeado a 1h
    },    
    {
        title: 'Masaje Relajante Largo',
        altTitle: 'Masaje Relajante Largo (1h25)',
        text: 'Alivia tensiones y estrés. Sesión más larga para una relajación profunda.',
        img: relajanteLargo,
        imgFull: relajanteLargo,
        precio: 50,
        duracion: 80,
        duracionBloque: 90, // Redondeado a 1h30min
    },
    {
        title: 'Sesión de Relajación Premium',
        altTitle: 'Sesión de Relajación Premium (1h50)',
        text: 'Para hacer un paréntesis. Un antes y después; un momento de pausa. Sesión multisensorial para una relajación profunda.',
        img: craneoFacial,
        imgFull: craneoFacial,
        precio: 69,
        duracion: 110,
        duracionBloque: 120, // Redondeado a 2h
    },
    {
        title: 'Masaje Descontracturante Cervical',
        altTitle: 'Masaje Descontracturante Cervical (50min)',
        text: 'Alivia tensiones y contracturas en la zona cervical.',
        img: descontracturanteCervical,
        imgFull: descontracturanteCervical,
        precio: 30,
        duracion: 50,
        duracionBloque: 60,
    },
    {
        title: 'Masaje Descontracturante de Lumbar',
        altTitle: 'Masaje Descontracturante de Lumbar (50min)',
        text: 'Alivia tensiones y contracturas en la zona lumbar.',
        img: descontracturanteEspalda,
        imgFull: descontracturanteEspalda,
        precio: 30,
        duracion: 50,
        duracionBloque: 60,
    },
    {
        title: 'Masaje Descontracturante de Piernas',
        altTitle: 'Masaje Descontracturante de Piernas (50min)',
        text: 'Alivia tensiones y contracturas en la zona de las piernas.',
        img: descontracturantePiernas,
        imgFull: descontracturantePiernas,
        precio: 30,
        duracion: 50,
        duracionBloque: 60,
    },
    /*
    {
        title: 'Masaje Descontracturante Completo Corto',
        altTitle: 'Masaje Descontracturante Completo Corto (45min)',
        text: 'Reserva este masaje si necesitas que tratemos varias zonas.',
        img: descontracturanteCorto,
        imgFull: descontracturanteCorto,
        precio: 30,
        duracion: 45,
        duracionBloque: 60,
    },
    */
    {
        title: 'Masaje Descontracturante Completo Largo',
        altTitle: 'Masaje Descontracturante Completo Largo (1h25)',
        text: 'Alivia tensiones y contracturas en todo el cuerpo con un enfoque más profundo.',
        img: descontracturanteLargo,
        imgFull: descontracturanteLargo,
        precio: 50,
        duracion: 80,
        duracionBloque: 90,
    },
    /*
    {
        title: 'Masaje de Pies',
        altTitle: 'Masaje de Pies (25min)',
        text: 'Masaje terapéutico para relajar los músculos y mejorar la circulación en los pies.',
        img: piesVertical,
        imgFull: origPies,
        precio: 30,
    },
    {
        title: 'Masaje Craneo-facial',
        altTitle: 'Masaje Craneo-facial (25min)',
        text: 'Masaje relajante que alivia tensiones en la cabeza y el rostro.',
        img: craneoFacial,
        imgFull: craneoFacial,
        precio: 30,
    },
    */
    {
        title: 'Masaje Anticelulítico',
        altTitle: 'Masaje Anticelulítico (50min / 5 sesiones)',
        text: 'Masaje estético reductor, ayuda a reducir la apariencia de la celulitis. Será necesario reservar 5 sesiones como mínimo.',
        img: anticelulitico,
        imgFull: anticelulitico,
        precio: 90,
        duracion: 50,
        duracionBloque: 60,
    },
    {
        title: 'Masaje Deportivo',
        altTitle: 'Masaje Deportivo (50min)',
        text: 'Para preparar competiciones, mejorar tu rendimiento y recupera músculos.',
        img: deportivoVertical,
        imgFull: deportivoVertical,
        precio: 30,
        duracion: 50,
        duracionBloque: 60,
    },
    {
        title: 'Masaje Circulatorio',
        altTitle: 'Masaje Circulatorio (50min)',
        text: 'Masaje que mejora la circulación sanguínea y linfática. Ideal para personas mayores.',
        img: circulatorio,
        imgFull: circulatorio,
        precio: 30,
        duracion: 50,
        duracionBloque: 60,
    },

    // {
    //   title: 'Masaje Shiatsu',
    //   ...
    // }  
];

export { listaMasajes };